import { getApiBase } from '../../lib/apiBase';
import type { SiteConfig } from '../../types/cms';

export interface AdminAuth {
  username?: string;
  password: string;
}

function apiUrl(path: string): string {
  const base = getApiBase();
  return `${base}${path}`;
}

export async function login(auth: AdminAuth): Promise<{ token: string }> {
  const res = await fetch(apiUrl('/api/auth/login'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(auth),
  });
  const data = (await res.json()) as { token?: string; error?: string };
  if (!res.ok) throw new Error(data.error || '登入失敗');
  if (!data.token) throw new Error('登入回應缺少 token');
  return { token: data.token };
}

export async function fetchCMSData(token: string): Promise<SiteConfig> {
  const res = await fetch(apiUrl('/api/cms/data'), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function saveCMSData(
  sectionKey: string,
  data: unknown,
  token: string
): Promise<SiteConfig> {
  const res = await fetch(apiUrl('/api/cms/data'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ [sectionKey]: data }),
  });
  const result = (await res.json()) as SiteConfig & { error?: string };
  if (!res.ok) throw new Error(result.error || `HTTP ${res.status}`);
  return result;
}

export async function resetCMSData(token: string): Promise<SiteConfig> {
  const res = await fetch(apiUrl('/api/cms/reset'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  const data = (await res.json()) as SiteConfig & { error?: string };
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
}
